import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  CalculatorOutlined,
  EyeOutlined,
  ShoppingCartOutlined,
  CarOutlined,
} from '@ant-design/icons'
import { Tooltip, Divider, Tag } from 'antd'
import moment from 'moment-business-days'
import DisplayIVA from '../common/DisplayIVA'
import DisplayStock from '../common/DisplayStock'
import DisplayAmount from '../common/DisplayAmount'
import { getProductImagePath, isNewProduct } from '../../lib/CatalogUtils'
import { hasDiagram } from '../../Utils/methodsUtils'
import { withTranslation } from 'react-i18next'

import { showItemDetail, addItemToOrder, addItemToQuotation, showDealModal } from '../../actions'
import { trackAnalyticsCommerceEvent } from '../../Utils/AnalyticsUtils'
import Favorite from '../common/Favorite'

class CatalogItemCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      width: 0,
      fileSelectedPos: null,
    }
  }

  // CustomLabel for Google Analytics events triggered from this component
  GA_LABEL = 'Producto - vista tarjetas'

  showDetail(data) {
    const { item, addItemToOrder, addItemToQuotation, user } = this.props
    const {
      id,
      codigodearticulo,
      descripcion,
      preciolista,
      tipodeiva,
      cantidadminima,
      multiplo,
      semaforo,
      semaforo_1000,
      semaforo_1100,
      semaforo_1200,
    } = item

    let quantity = 1
    if (cantidadminima && multiplo && multiplo > 0) {
      quantity =
        cantidadminima > multiplo ? Math.ceil(cantidadminima / multiplo) * multiplo : multiplo
    } else if (cantidadminima) {
      quantity = cantidadminima
    }

    // TODO: Just send required fields
    const itemAdd = {
      id,
      codigodearticulo,
      descripcion,
      precio: preciolista,
      cantidad: quantity,
      tipodeiva,
      observaciones: '',
      semaforo,
      semaforo_1000,
      semaforo_1100,
      semaforo_1200,
    }

    const analyticsEventParams = [
      {
        item_id: codigodearticulo,
        item_name: descripcion,
        quantity,
        price: preciolista,
      },
    ]

    const trackEvent = (action) => {
      trackAnalyticsCommerceEvent(
        action,
        this.GA_LABEL,
        codigodearticulo,
        user,
        preciolista,
        analyticsEventParams,
      )
    }

    const actions = {
      cart: () => {
        addItemToOrder({ item: itemAdd })
        trackEvent('add_to_cart')
      },
      estimate: () => {
        addItemToQuotation({ item: itemAdd })
        trackEvent('add_to_quoter')
      },
      view: () => {
        const payload = { ...data, showDealLabel: true, item: { ...this.props.item } }
        this.props.showItemDetail(payload)
        trackEvent('view_item')
      },
    }

    if (actions[data.action]) {
      actions[data.action]()
    }
  }

  checkDealPrice(product) {
    let result = null
    if (product.preciooferta) {
      const today = moment()
      if (
        product.oferta_fechafin &&
        moment(product.oferta_fechafin).isAfter(today) &&
        product.oferta_fechainicio &&
        moment(product.oferta_fechainicio).isBefore(today)
      ) {
        result = product.preciooferta
      }
    }
    return result
  }

  openDealModal = (record, action) => {
    const payload = { showModal: true, dealItem: { ...record } }
    this.props.showDealModal(payload)
  }

  render() {
    let inc = 0
    const {
      item,
      isMobile,
      showEstimateBtn,
      showAddToCartBtn,
      showFavoriteBtn,
      t,
      onOpenDiagramModal,
    } = this.props

    const descripcioncatalogo = item.descripcioncatalogo
    const length = 75
    const dealPrice = this.checkDealPrice(item)
    const hasDiagramResult = hasDiagram(item)

    return (
      <div className='catalog-item-card-wrapper'>
        <div className='catalog-item-card'>
          <div className={'catalog-item-card-title red-gradient'}>
            <div className='ml-1' onClick={() => this.showDetail({ show: true, action: 'view' })}>
              {item.codigodearticulo}
            </div>
            <div className='catalog-item-card-actions actions'>
              <div className='catalog-item-card-actions-buttons mr-2'>
                {hasDiagramResult && (
                  <Tooltip title={t('View diagram')} trigger={isMobile ? 'none' : 'hover'}>
                    <CarOutlined
                      className='icon-card-item'
                      onClick={() => onOpenDiagramModal(item)}
                      style={{ cursor: 'pointer' }}
                    />
                  </Tooltip>
                )}
                <Tooltip title={t('Details')}>
                  <a onClick={() => this.showDetail({ show: true, action: 'view' })}>
                    <EyeOutlined className='icon-card-item' data-testid='eyeAntdIcon' />
                  </a>
                </Tooltip>
                {showFavoriteBtn && (
                  <a className='icon-card-item'>
                    <Favorite className='icon-card-item' product={item} GA_LABEL={this.GA_LABEL} />
                  </a>
                )}
                {showEstimateBtn && (
                  <Tooltip title={t('Add products to quotation')}>
                    <a onClick={() => this.showDetail({ show: true, action: 'estimate' })}>
                      <CalculatorOutlined
                        className='icon-card-item'
                        data-testid='calculatorAntdIcon'
                      />
                    </a>
                  </Tooltip>
                )}
                {showAddToCartBtn && (
                  <Tooltip title={t('Add products to cart')}>
                    <a onClick={() => this.showDetail({ show: true, action: 'cart' })}>
                      <ShoppingCartOutlined className='icon-card-item' data-testid='cartAntdIcon' />
                    </a>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
          <div className='catalog-item-card-picture-prices'>
            <div className='catalog-item-card-prices'>
              <div className='catalog-item-secondary-data'>
                <div className='catalog-item-card-stock'>
                  <div>{t('Stock')}:</div>
                  <DisplayStock product={item} />
                </div>
              </div>
            </div>
            <div
              className='catalog-item-card-picture'
              onClick={() => this.showDetail({ show: true, action: 'view' })}
            >
              {isNewProduct(item.createdAt) && (
                <span className='textLabelCardContent'>{t('newProduct')}</span>
              )}
              <img src={getProductImagePath(item)} />
            </div>
          </div>
          <div className='catalog-item-card-bottom'>
            <div className='catalog-item-card-detail'>
              <p style={{ height: 30 }}>
                {!(descripcioncatalogo.length > length)
                  ? descripcioncatalogo
                  : `${descripcioncatalogo.substring(0, length)}...`}
              </p>
              {item && item.isInOffer && (
                <Tag
                  color='#fe4e37'
                  style={{ borderRadius: '7px' }}
                  onClick={() => this.openDealModal(item.isInOffer)}
                >
                  <a href='#'>{t('volumeDeal')}</a>
                </Tag>
              )}
              {item.marcas && item.marcas.length > 0 && item.marcas[0] !== undefined && (
                <Tag
                  color='red'
                  style={{ marginBottom: '5px', marginTop: '5px' }}
                  key={`${inc++}_${item.marcas[0].id}_${item.marcas[0].descripcion}_${new Date().getTime()}`}
                >
                  {item.marcas[0].descripcion}
                </Tag>
              )}
            </div>
            <Divider className='item-card-bottom-divider' />
            <div
              style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around' }}
            >
              <div className='catalog-item-card-price'>
                <div>
                  {t('Wholesale Price')}
                  <span>
                    <DisplayAmount
                      position='center'
                      amount={item.preciolista}
                      currency={item.moneda_preciolista}
                    />
                  </span>
                </div>
                <div className='catalog-item-card-iva'>
                  <div className='mr-1'>{t('VAT')}:</div>
                  <DisplayIVA iva={item.tipodeiva} />
                </div>
              </div>
              <div className={`catalog-item-card-price ${dealPrice ? 'deal-price' : ''}`}>
                <div>
                  {t('Sale Price')}
                  <span>
                    <DisplayAmount
                      position='center'
                      amount={dealPrice}
                      currency={item.moneda_preciooferta}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ orders, quotation, catalog, auth }) => {
  const selectedSegment = catalog.catalogSegment
  const { current } = orders
  const currentQuotation = quotation.current
  const { searchRequest } = catalog
  const { user } = auth.user
  return {
    current,
    currentQuotation,
    user,
    selectedSegment,
    filter: searchRequest.filter,
  }
}

export default connect(mapStateToProps, {
  showItemDetail,
  addItemToOrder,
  addItemToQuotation,
  showDealModal,
})(withTranslation()(CatalogItemCard))
